<div appFillHeight class="w-100 h-100 scrollbar d-flex flex-column py-5">
  @if (!results) {
    <div class="row gx-0 justify-content-center mt-auto">
      <div class="col-auto gx-0 pe-5">
        <div class="file-input">
          <ngx-file-drop
            dropZoneLabel="Baseline XER"
            accept=".xer"
            [directory]="false"
            [multiple]="false"
            (onFileDrop)="uploadBaseline($event)">
            <ng-template ngx-file-drop-content-tmp let-openFileSelector="openFileSelector">
              <div class="container-fluid">
                <div class="row gx-0 justify-content-center pb-2 pt-2">Base XER</div>
                @if (baseName) {
                  <div class="row gx-0 justify-content-center pb-2">Current: {{ baseName }}</div>
                }
                <div class="row gx-0 justify-content-center pb-2">
                  <div class="col-auto gx-0">
                    <button matButton="outlined" (click)="openFileSelector()">Browse XERs</button>
                  </div>
                </div>
              </div>
            </ng-template>
          </ngx-file-drop>
        </div>
      </div>
      <div class="col-auto gx-0 ps-5">
        <div class="file-input">
          <ngx-file-drop
            dropZoneLabel="Latest XER"
            accept=".xer"
            [directory]="false"
            [multiple]="false"
            (onFileDrop)="uploadLatest($event)">
            <ng-template ngx-file-drop-content-tmp let-openFileSelector="openFileSelector">
              <div class="container-fluid">
                <div class="row gx-0 justify-content-center pb-2 pt-2">Updated XER</div>
                @if (updatedName) {
                  <div class="row gx-0 justify-content-center pb-2">Current: {{ updatedName }}</div>
                }
                <div class="row gx-0 justify-content-center pb-2">
                  <div class="col-auto gx-0">
                    <button matButton="outlined" (click)="openFileSelector()">Browse XERs</button>
                  </div>
                </div>
              </div>
            </ng-template>
          </ngx-file-drop>
        </div>
      </div>
    </div>
    <div class="row gx-0 justify-content-center pt-5 mb-auto">
      <div class="col-auto gx-0">
        <button matButton="filled" (click)="submitFiles()" [disabled]="!submitReady">Submit</button>
      </div>
    </div>
  } @else {
    <div class="row justify-content-center gx-0 mt-auto">
      <div class="col-6 gx-0">
        <div class="row justify-content-center gx-0">
          @for (cat of results | keyvalue; track $index) {
            <div class="col-12 col-md-6 col-xl-4 col-xxl-2 gx-0 px-3 pb-3 result-card">
              <mat-card appearance="outlined">
                <mat-card-header>
                  <mat-card-title>{{ cat.key === 'wbs' ? cat.key.toUpperCase() : (cat.key | titlecase) }}</mat-card-title>
                </mat-card-header>
                <mat-card-content>
                  @if (cat.value !== undefined && cat.value !== null) {
                    <div class="row gx-0 pb-2">
                      <div class="col-6 gx-0">
                        <div class="row gx-0">Added</div>
                        <div class="row gx-0">Changed</div>
                        <div class="row gx-0">Removed</div>
                      </div>
                      <div class="col-6 gx-0 ps-5">
                        <div class="row gx-0">{{ cat.value.added }}</div>
                        <div class="row gx-0">{{ cat.value.changed }}</div>
                        <div class="row gx-0">{{ cat.value.removed }}</div>
                      </div>
                    </div>
                  } @else {
                    No results
                  }
                </mat-card-content>
              </mat-card>
            </div>
          }
        </div>
      </div>
    </div>
    <div class="row gx-0 justify-content-center pt-3 mb-auto">
      <div class="col-auto gx-0">
        <button matButton="filled" (click)="reset()">Compare Again</button>
      </div>
    </div>
  }
</div>